import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { ErrorBoundary } from '@register-ui/components';
import { csrfTokenManager } from '@register-ui/utils';
import App from './app/app';
import './style.scss';

window.__HOST_UI_VERSION__ = __HOST_UI_VERSION__;

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

root.render(
    <StrictMode>
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    </StrictMode>,
);

csrfTokenManager.startProactiveRefresh();
